<template>
  <div
    class="pch-textchat-widget elevation-4"
    :class="{ 'pch-home': !($store.state.page || $store.getters.termsVisible), 'pch-page': !!($store.state.page || $store.getters.termsVisible) }"
  >
    <div
      class="pch-widget-header"
      :style="{ backgroundColor: color }"
    >
      <div
        class="d-flex flex-grow-1"
      >
        <!-- <div
          v-if="$store.state.widget && $store.state.widget.settings && $store.state.widget.settings.logo && !($store.state.page || $store.getters.termsVisible)"
          class="banner-logo"
          style="flex-grow: 1; overflow: hidden; padding-bottom: 8px;"
        >
          <img
            :src="`https://s3.amazonaws.com/s.citygro.com/edn/public/${$store.state.widget.settings.logo}`"
            style="max-width: 100%; max-height: 100%; height: 100%;"
          />
        </div> -->
        <div
          class="banner-title flex-grow-1"
        >
          <v-btn
            v-if="$store.state.page || $store.getters.termsVisible"
            icon
            dark
            small
            @click="$store.commit($store.getters.termsVisible ? 'setShowTerms' : 'setPage', null)"
            :disabled="($store.state.loading && !$store.getters.termsVisible) || $store.getters.requireAcceptTerms"
            style="margin-right: 10px;"
          >
            <v-icon small>fa fa-chevron-left</v-icon>
          </v-btn>
          <span>{{ $renderSmartText($store.getters.bannerTitle) }}</span>
        </div>
      </div>
      <div class="pch-close">
        <v-btn
          icon
          dark
          small
          style="margin-right: 10px;"
          @click="$root.close"
        >
          <v-icon small>fa fa-times</v-icon>
        </v-btn>
      </div>
    </div>
    <div
      class="pch-widget-content"
      ref="scroller"
    >
      <div
        v-if="$store.state.initialLoading"
        style="text-align: center; height: 100%; display: flex; align-items: center; justify-content: center;"
      >
        <v-progress-circular
          indeterminate
          size="50"
          v-bind="{ color }"
        />
      </div>
      <div
        v-else-if="$store.state.fatalError"
        class="pa-5"
      >
        <v-alert
          :color="$store.getters.color"
          dark
        >{{ $store.state.fatalError }}</v-alert>
      </div>
      <widget-terms
        v-else-if="$store.getters.termsVisible"
      />
      <div
        v-show="!$store.getters.termsVisible"
        style="min-height: 100%; height: 100%"
      >
        <div
          v-if="$store.state.error"
          class="pa-3"
        >
          <v-alert
            color="error"
            dark
          >{{ $store.state.error }}</v-alert>
        </div>
        <widget-done
          v-else-if="$store.state.page === 'done'"
        />
        <widget-home
          v-else
        />

        <!-- <div
          style="height: 70px; padding-top: 10px;"
        >
          <div
            style="text-align: center; font-size: 14px; font-weight: bold; opacity: 0.6;"
          ><img :src="logoSvg" style="width: 17px; height: 17px;" /><div style="display: inline-block; margin-left: 8px; height: 17px; vertical-align: top;">Powered by Patch</div></div>
          <div
            style="text-align: center; font-size: 10px; font-weight: bold; margin-top: 5px; margin-bottom: 20px"
          >
            <a
              style="text-decoration: underline; cursor: pointer;"
              :style="{ color }"
              @click="$store.commit('setShowTerms', true)"
            >Terms &amp; Conditions</a>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.pch-textchat-widget {
  overflow: hidden;
  font-family: Nunito;
  max-width: 100%;
  width: 100%;
  height: 100%;
  .pch-widget-header {
    height: 60px;
    color: #ffffff;
    display: flex;
    align-items: center;
    .banner-title {
      font-size: 1em;
      text-align: center;
      // text-transform: uppercase;
    }
  }
  .pch-close {
    position: absolute;
    right: 0;
    top: 15px;
  }
  .pch-widget-content {
    background-color: #fff;
    overflow: auto;
    height: calc(100% - 60px);
  }
  &.pch-page {
    .pch-widget-header {
      align-items: center;
      padding: 5px;
      padding-left: 10px;
      .banner-title {
        display: flex;
        align-items: center;
        line-height: 22px;
      }
    }
  }
}
</style>

<script>
import WidgetHome from './home/Home.vue'
import WidgetDone from './done/Done.vue'
import WidgetTerms from './terms/Terms.vue'
import logoSvg from '../../public/patch-logo.svg'

export default {
  components: {
    WidgetHome,
    WidgetDone,
    WidgetTerms
  },
  computed: {
    logoSvg () {
      return logoSvg
    },
    color () {
      return this.$store.getters?.color
    },
    page () {
      return this.$store?.state?.page
    },
    termsVisible () {
      return this.$store?.getters?.termsVisible
    }
  },
  watch: {
    page () {
      if (this.$refs.scroller) {
        this.$refs.scroller.scrollTop = 0
      }
    },
    termsVisible () {
      if (this.$refs.scroller) {
        this.$refs.scroller.scrollTop = 0
      }
    }
  }
}
</script>
